const getImportantColumns = () => MAIN_SET_DATA;
export default getImportantColumns;

const MAIN_SET_DATA = {
  'S4_EC_01._scoring.score_final': {
    average: 11.57190635451505,
    // label: 'Access to local market (for selling any crops or livestock)',
    label: 'Access to local market',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_EC_02._scoring.score_final': {
    average: 13.015545685279188,
    label: 'Financial support',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_EC_03._scoring.score_final': {
    average: 11.637931034482758,
    label: 'Market access - buying',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_EC_04._scoring.score_final': {
    average: 11.28448275862069,
    label: 'Market access - selling',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_EC_05._scoring.score_final': {
    average: 8.592357723577233,
    label: 'Market prices',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_EC_06._scoring.score_final': {
    average: 13.084615384615384,
    label: 'Market information access',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_EC_07._scoring.score_final': {
    average: 16.70212765957447,
    label: 'Information and Communication Technologies (ICTs)',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_EC_08._scoring.score_final': {
    average: 4.502427184466019,
    label: 'Insurance',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_EC_09._scoring.score_final': {
    average: 17.061501210653752,
    label: 'Major productive access',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_EC_10._scoring.score_final': {
    average: 3.467597208374875,
    label: 'Main expenditures',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_EC_11._scoring.score_final': {
    average: 12.284100657706606,
    label: 'Income sources',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_EC_12._scoring.score_final': {
    average: 10.758207303578015,
    label: 'Nonfarm Income Generating Activities (IGA)',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_EC_13._scoring.score_final': {
    average: 11.784180138568102,
    label: 'Local farm inputs',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_EC_14._scoring.score_final': {
    average: 10.744029393753827,
    label: 'Savings',
    min: 0,
    max: 0,
    stdDev: 0,
  },

  'S4_ENV_01._scoring.score_final': {
    average: 11.680951025056947,
    label: 'Water access',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_ENV_02._scoring.score_final': {
    average: 9.537650054565297,
    label: 'Water conservation techniques and practices',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_ENV_03._scoring.score_final': {
    average: 15.854391891891812,
    label: 'Water Quality',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_ENV_04._scoring.score_final': {
    average: 12.21040167865696,
    label: 'Land access',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_ENV_05._scoring.score_final': {
    average: 12.638804841149751,
    label: 'Soil quality and land degradation',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_ENV_06._scoring.score_final': {
    average: 12.91384747706422,
    label: 'Land management practices',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_ENV_07._scoring.score_final': {
    average: 13.52001404494382,
    label: 'Leguminous plants',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_ENV_08._scoring.score_final': {
    average: 12.450642523364486,
    label: 'Buffer zones (unmanaged areas surrounding the field)',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_ENV_09._scoring.score_final': {
    average: 11.609148264984237,
    label: 'Energy sources',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_ENV_10._scoring.score_final': {
    average: 8.968580715059588,
    label: 'Energy conservation',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_ENV_11._scoring.score_final': {
    average: 10.482940996637117,
    label: 'Fertilizers',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_ENV_12._scoring.score_final': {
    average: 13.209793566970715,
    label: 'Weed species and management',
    min: 0,
    max: 0,
    stdDev: 0,
  },

  'S4_GOV_01._scoring.score_final': {
    average: 11.826530612244898,
    label: 'Government policies',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_GOV_02._scoring.score_final': {
    average: 13.195043103448276,
    label: 'Customary rules related to climate change & agriculture',
    min: 0,
    max: 0,
    stdDev: 0,
  },

  'S4_PSP_01._scoring.score_final': {
    average: 14.992909397861313,
    label: 'Household',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_PSP_02._scoring.score_final': {
    average: 14.076814459192319,
    label: 'Production activities',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_PSP_03._scoring.score_final': {
    average: 0.047726358148893366,
    label: 'Aquaculture',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_PSP_04._scoring.score_final': {
    average: 12.121876766534996,
    label: 'Crops',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_PSP_05._scoring.score_final': {
    average: 6.441524538809607,
    label: 'Livestock practices',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_PSP_06._scoring.score_final': {
    average: 7.386747802569303,
    label: 'Animal/livestock breeding',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_PSP_07._scoring.score_final': {
    average: 6.811058344640428,
    label: 'Animal nutrition',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_PSP_08._scoring.score_final': {
    average: 12.272140762463275,
    label: 'Seed/breed sources',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_PSP_09._scoring.score_final': {
    average: 12.017647058823526,
    label: 'Utilisation of new varieties and breeds',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_PSP_10._scoring.score_final': {
    average: 10.944726631393424,
    label: 'Trees and Agroforestry',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_PSP_11._scoring.score_final': {
    average: 11.201379310344786,
    label: 'Crop and livestock losses',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_PSP_12._scoring.score_final': {
    average: 9.267263427109974,
    label: 'Record keeping',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_PSP_13._scoring.score_final': {
    average: 17.420454545454547,
    label: 'Infrastructure',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_PSP_14._scoring.score_final': {
    average: 13.55075348308232,
    // label:
    //   'Access to information on climate change, adaptation practices, and meteorological forecasts',
    label: 'Access to information',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_PSP_15._scoring.score_final': {
    average: 10.41343669250646,
    label: 'Animal disease control practices',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_PSP_16._scoring.score_final': {
    average: 11.08989850169164,
    label: 'Pest management practices',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_PSP_17._scoring.score_final': {
    average: 11.435976408912188,
    label: 'Synthetic Pesticide use',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_PSP_18._scoring.score_final': {
    average: 12.650257289879901,
    label: 'Intercropping',
    min: 0,
    max: 0,
    stdDev: 0,
  },

  'S4_SOC_01._scoring.score_final': {
    average: 13.098317650413572,
    label: 'Group membership',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_SOC_02._scoring.score_final': {
    average: 11.311708860759493,
    label: 'Meals',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_SOC_03._scoring.score_final': {
    average: 12.167305848513902,
    label: 'Disturbances',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_SOC_04._scoring.score_final': {
    average: 11.583224967490247,
    label: 'Veterinary Access',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_SOC_05._scoring.score_final': {
    average: 14.57915647921756,
    label: 'Trust and cooperation',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_SOC_06._scoring.score_final': {
    average: 14.334961997828447,
    label: 'Previous collective action',
    min: 0,
    max: 0,
    stdDev: 0,
  },
  'S4_SOC_07._scoring.score_final': {
    average: 15.603852327447752,
    label: 'Household decision-making',
    min: 0,
    max: 0,
    stdDev: 0,
  },
};



// WEBPACK FOOTER //
// ./src/data/dataColumns.js